import axios from 'axios';

const state = {};

const getters = {};

const actions = {
	// Accoda la riscrittura IA dei testi prodotto.
	// Ritorna { data: { jobId } } oppure { error }.
	requestRewrite: async (context, payload) => {
		let url = 'itemrewrite';

		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					name: payload.name,
					text: payload.text || '',
					lang: payload.lang,
					itemId: payload.itemId || undefined,
					tone: payload.tone || undefined,
					kind: payload.kind || undefined,
					// ottimizzazione SEO: keyword e meta attuali; slug e alt servono al punteggio prima/dopo
					keyword: payload.keyword || undefined,
					metatitle: payload.keyword ? payload.metatitle || '' : undefined,
					metadescription: payload.keyword ? payload.metadescription || '' : undefined,
					slug: payload.keyword ? payload.slug || '' : undefined,
					alts: payload.keyword && Array.isArray(payload.alts) ? payload.alts : undefined,
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)
			.then(res => {
				return res.data;
			})
			.catch(err => {
				return { error: err.response ? err.response.data : err.message };
			});
	},

	// Stato del job: usato come fallback quando il socket non consegna l'esito.
	fetchJob: async (context, jobId) => {
		let url = `itemrewrite/${jobId}`;

		return await axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
			})
			.then(res => {
				return res.data;
			})
			.catch(err => {
				return { error: err.response ? err.response.data : err.message };
			});
	},
};

const mutations = {};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
